import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { Router } from '@angular/router';
import { SnackService } from '../../service/snack.service';
import { statusType } from '../../interfaces/enumStatusType';

@Component({
  selector: 'app-login-form',
  standalone: false,

  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss'
})
export class LoginFormComponent {
  hidespinner: boolean = true;
  loginForm: FormGroup;
  constructor(
    private authService: AuthandregistryService,
    private _fb: FormBuilder,
    private router: Router,

    private snack: SnackService
  ) {
    this.loginForm = this._fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
    authService.doAutoLogin();
    // setTimeout(() => {
    //   snack.snackHeadline.next('Welcome to the Login');
    //   snack.snackText.next('Please login to access your account');
    //   snack.type.next(statusType.Warning);
    //   snack.showSnack.next(true);
    // }, 2000);
  }


  async onSubmit() {
    if (this.loginForm.invalid || typeof this.loginForm.value.email !== 'string' || typeof this.loginForm.value.password !== 'string') return;

    this.hidespinner = false;
    // localStorage.setItem('ids_be_loginemail', this.loginForm.value.email)
    await this.authService.doLogin(this.loginForm.value.email, this.loginForm.value.password);
    this.hidespinner = true;
  }

  gotopwforgotten() {
    if (this.loginForm.value.email != '' && this.loginForm.value.email) sessionStorage.setItem('email', this.loginForm.value.email);
    this.router.navigate(['/login/password-forgotten']);
  }
}
